import { useList, useDetail, useCreate, useUpdate, useDelete, fetchApi } from "@inmagik/react-crud"
import { Tecnica } from "../types"
import { API_URL } from "../constants"
import { useCallback } from "react"
import { normalizeParams } from "@inmagik/react-crud/dist/crud/utils"
import { useAuth } from "../auth"

export function useTecnicheList(
  params: // accept also list of ids
  Record<string, string | number | Array<number>> = {},
  enabled = true
) {
  return useList<Tecnica>(`${API_URL}/admin/tecniche-immagini`, {
    query: params,
    reactQuery: {
      enabled: enabled,
      queryKey: ["tecniche", params],
    },
  })
}

export function useTecnica(id: number | undefined) {
  return useDetail<Tecnica>(`${API_URL}/admin/tecniche-immagini`, id?.toString())
}

export function useTecnicaLazy() {
  const auth = useAuth()
  return useCallback((id: number) => {
    return fetchApi(`${API_URL}/admin/tecniche-immagini/${id}`, {
      method: "GET",
      responseType: "json",
      headers: {
        Authorization: `Bearer ${auth.tokens?.access}`,
      },
    }) as Promise<Tecnica>
  }, [])
}

export function useTecnicheLazy() {
  const auth = useAuth()
  return useCallback((params: Record<string, string | number | Array<number>>) => {
    const qs = normalizeParams(params).toString()
    return fetchApi(`${API_URL}/admin/tecniche-immagini?${qs}`, {
      method: "GET",
      responseType: "json",
      headers: {
        Authorization: `Bearer ${auth.tokens?.access}`,
      },
    }) as Promise<{ results: Tecnica[] }>
  }, [])
}

export function useTecnicaCreate() {
  return useCreate<Tecnica>(`${API_URL}/admin/tecniche-immagini`)
}

export function useTecnicaUpdate() {
  return useUpdate<Tecnica>(`${API_URL}/admin/tecniche-immagini`)
}

export function useTecnicaDelete() {
  return useDelete(`${API_URL}/admin/tecniche-immagini`)
}
